class ProductMatching extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setPrice = this.setPrice()
    this.setButtonText()
  }

  setupListeners () {
    this.onSubmitHandler = this.onSubmitHandler.bind(this)

    this.listeners.add(this.els.button.element, 'click', this.onSubmitHandler)
    this.listeners.add(this, 'click', this.setPrice.bind(this))
    this.listeners.add(this, 'click', this.setButtonText.bind(this))
    this.listeners.add(this, 'click', this.setItems.bind(this))
  }

  setPrice () {
    if (this.optionVariants.length > 0) {
      this.totalPrice = 0
      this.optionVariants.forEach((variant) => {
        this.totalPrice +=
          parseFloat(
            variant.dataset.price *
              variant.querySelector(`[data-product-matching-el="quantity"]`)
                .value,
          ) || 0
      })
      this.els.price.element.innerHTML =
        this.dataset.currency + (this.totalPrice / 100).toFixed(2)

      this.totalItems = 0
      this.optionVariants.forEach((variant) => {
        this.totalItems +=
          parseFloat(
            variant.querySelector(`[data-product-matching-el="quantity"]`)
              .value,
          ) || 0
      })

      if (this.totalItems === 1) {
        this.els.label.element.innerHTML = `${window.matchingStrings.one_item}`
      } else {
        this.els.label.element.innerHTML = `${window.matchingStrings.for} ${this.totalItems} ${window.matchingStrings.items}`
      }

      this.els.button.element.disabled = false
    } else {
      this.els.label.element.innerHTML = ``
      this.els.price.element.innerHTML = `${this.dataset.currency}0`

      this.els.button.element.disabled = true
    }
  }

  setButtonText () {
    const buttonTextEl = this.els.button.element?.querySelector(
      '[data-product-add-to-cart-text]',
    )

    if (!buttonTextEl) return

    if (!buttonTextEl.dataset.defaultText) {
      buttonTextEl.dataset.defaultText = buttonTextEl.textContent.trim()
    }

    buttonTextEl.textContent =
      this.optionVariants.length > 0
        ? window.variantStrings?.addToCart || buttonTextEl.dataset.defaultText
        : buttonTextEl.dataset.defaultText
  }

  setItems () {
    this.els.item.elements.forEach((item) => {
      this.totalItems = 0
      item
        .querySelectorAll(`[data-product-matching-el="quantity"]`)
        .forEach((variant) => {
          this.totalItems += variant.value || 0
        })

      item.classList.toggle('prd-Matching_Item-active', this.totalItems > 0)

      if (this.totalItems > 1) {
        item.querySelector(`[data-product-matching-el="selected"]`).innerHTML =
          `<span class="prd-Matching_Number fz-14_140">${this.totalItems}</span> ${window.matchingStrings.items_selected} <span class="prd-Matching_Edit">${window.matchingStrings.edit}</span>`
      } else if (this.totalItems === 1) {
        item.querySelector(`[data-product-matching-el="selected"]`).innerHTML =
          `<span class="prd-Matching_Number fz-14_140">${this.totalItems}</span> ${window.matchingStrings.item_selected} <span class="prd-Matching_Edit">${window.matchingStrings.edit}</span>`
      } else {
        item.querySelector(`[data-product-matching-el="selected"]`).innerHTML =
          ``
      }
    })
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    const items = this.optionVariants.map((el) => ({
      id: parseInt(el.querySelector(`[name="id_matching"]`).value),
      quantity: el.querySelector(`[data-product-matching-el="quantity"]`).value,
    }))

    return window.BAO.Cart.addItem(items)
  }

  get optionVariants () {
    const variants = []
    this.els.variant.elements.forEach((variant) => {
      if (
        variant.querySelector(`[data-product-matching-el="quantity"]`)?.value >
        0
      ) {
        variants.push(variant)
      }
    })

    return variants
  }
}

if (!customElements.get('product-matching')) {
  customElements.define('product-matching', ProductMatching)
}
